import axios from 'axios';

export default {
    list() {
        return axios.get(window.applicationSettings.apiEndpoint + '/risk/country/list')
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    },
    fetch(countryId) {
        return axios.get(window.applicationSettings.apiEndpoint + '/risk/country/fetch/' + countryId)
            .then(response => response.data)
            .catch(error => error.response);
    },
    create(payload) {
        var formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        return axios.post(window.applicationSettings.apiEndpoint + '/risk/country/create', formData)
            .then(response => response.data)
            .catch(error => error.response);
    },
    update(countryId, payload) {
        var formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        return axios.post(window.applicationSettings.apiEndpoint + '/risk/country/update/' + countryId, formData)
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    },
    delete(countryId) {
        return axios.delete(window.applicationSettings.apiEndpoint + '/risk/country/delete/' + countryId)
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    }
}